import { TRESPONSE_ORDER_CHECKLIST_LISTING, TFilterSelected } from '@monorepo/types';
import { TFilterGroupModel, TUserPaginationOption } from '@monorepo/ui';

export type TOrderChecklistState = {
  orderChecklistInfo: TRESPONSE_ORDER_CHECKLIST_LISTING | null;
  userPaginationOption: TUserPaginationOption;
  orderChecklistSelectedFilters: TFilterGroupModel<TFilterSelected> | null;
};

export const TOrderChecklistActionType = {
  GetOrderChecklist: 'GET_ORDER_CHECKLIST' as const,
  GetOrderChecklistSuccess: 'GET_ORDER_CHECKLIST_SUCCESS' as const,
  GetOrderChecklistFailure: 'GET_ORDER_CHECKLIST_FAILURE' as const,
  SetUserPaginationOption: 'SET_ORDER_CHECKLIST_USER_PAGINATION_OPTION' as const,
  SetOrderChecklistSelectedFilters: 'SET_ORDER_CHECKLIST_SELECTED_FILTERS' as const,
  RefreshOrderChecklist: 'REFRESH_ORDER_CHECKLIST' as const,
};
